/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SelectField, SelectFieldOption } from '@squiz/sds';
import React, { Ref, forwardRef, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CONFIGURATION_STRINGS } from '../../../../Constants/Strings.constants';
import { DAM_INTEGRATIONS_DATA_IDS, DAM_INTEGRATIONS_FORM_IDS } from '../../DamIntegrations.constants';
import { DamIntegrationType } from '../../types/DamIntegrationsPublic/DamIntegrationsPublic';
import { SelectDamTypeProps } from './SelectDamType.props';

/**
 * Select field for DAM integration type.
 */
export const SelectDamType = forwardRef((props: SelectDamTypeProps, ref: Ref<HTMLInputElement>): JSX.Element => {
  const { t } = useTranslation();
  const { callback, errorMessage } = props;

  const labels = useMemo(() => {
    return {
      integrationType: t(CONFIGURATION_STRINGS.integrationType),
    };
  }, [t]);

  const selectOptions = Object.values(DamIntegrationType).map((type): SelectFieldOption => {
    return {
      key: type,
      label: type,
      value: type,
    };
  });

  const defaultOption = selectOptions[0];
  const defaultSelection = defaultOption.key as DamIntegrationType;

  const [selectedType, setSelectedType] = useState<DamIntegrationType>(defaultSelection);
  const handleTypeChange = (option: SelectFieldOption): void => {
    setSelectedType(option.key as DamIntegrationType);
    callback && callback();
  };

  return (
    <SelectField
      callback={handleTypeChange}
      data-id={DAM_INTEGRATIONS_DATA_IDS.type}
      defaultOption={defaultOption}
      errorMessage={errorMessage}
      fieldLabel={labels.integrationType}
      id={DAM_INTEGRATIONS_FORM_IDS.type}
      name={DAM_INTEGRATIONS_FORM_IDS.type}
      options={selectOptions}
      ref={ref}
      required
      value={selectedType}
    />
  );
});
